import 'globals';

(function($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.slick) {
            $('.slider__items').slick();

            if ($('.product-teaser .slick').length > 0) {
                $('.product-teaser .slick').each(function() {
                    $(this).slick({
                        slidesToShow: $(this).data('slidecount'),
                        slidesToScroll: 1,
                        dots: false,
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: $(this).data('slidecountmd'),
                                    slidesToScroll: 1,
                                    infinite: true
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: $(this).data('slidecountsm'),
                                    slidesToScroll: 1,
                                    infinite: true
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    slidesToShow: $(this).data('slidecountxs'),
                                    slidesToScroll: 1,
                                    infinite: true
                                }
                            }
                        ],
                        prevArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-prev"><span class="ai ai-chevron-left"></span></span>',
                        nextArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-next"><span class="ai ai-chevron-right"></span></span>',
                    });
                });
            }
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
